/* eslint-disable */

/*
 * ⚠️ DO NOT EDIT ⚠️
 * This file is automatically generated, run "yarn run codegen"
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type CompetitionQueryQueryVariables = Exact<{
  id: number;
}>;

export type CompetitionQueryQuery = {
  __typename: 'query_root';
  competitions_competition_detail_by_id:
    | Array<{
        __typename: 'competitions_competition_detail';
        id: number;
        name: string | undefined;
        age_category: string | undefined;
        family: string | undefined;
        fede_url: string | undefined;
        gender: string | undefined;
        league_id: number | undefined;
        level_id: number | undefined;
        level_in_season_id: number | undefined;
        level_slug: string | undefined;
        old_url: string | undefined;
        slug: string | undefined;
        competition:
          | {
              __typename: 'competitions_competition';
              id: number;
              current_round:
                | Array<{ __typename: 'competitions_round'; id: number }>
                | undefined;
            }
          | undefined;
        sport:
          | {
              __typename: 'clubs_sport';
              id: number;
              image: string | undefined;
              slug: string | undefined;
            }
          | undefined;
        rounds:
          | Array<{
              __typename: 'competitions_round';
              id: number;
              name: string | undefined;
              events:
                | Array<{
                    __typename: 'competitions_event';
                    id: number;
                    event_with_same_team:
                      | {
                          __typename: 'competitions_event_with_same_teams';
                          id: number;
                          slug: string | undefined;
                        }
                      | undefined;
                  }>
                | undefined;
            }>
          | undefined;
        rankings:
          | Array<{
              __typename: 'competitions_ranking_detail';
              id: number;
              name_in_competition: string | undefined;
              pts: unknown;
              rank: unknown;
              even: unknown;
              ga: unknown;
              gd: unknown;
              gf: unknown;
              logo: string | undefined;
              lost: unknown;
              played: unknown;
              ratio: unknown;
              team_id: number | undefined;
              team_in_season_id: number | undefined;
              win: unknown;
              club_id: number | undefined;
              url: string | undefined;
              serie: Array<number> | undefined;
              extra_columns: unknown;
            }>
          | undefined;
        league:
          | {
              __typename: 'competitions_league';
              slug: string | undefined;
              id: number;
              name: string | undefined;
            }
          | undefined;
        level:
          | {
              __typename: 'competitions_level';
              id: number;
              name: string | undefined;
            }
          | undefined;
      }>
    | undefined;
};

export type EventsByRoundIdQueryVariables = Exact<{
  roundId: number;
}>;

export type EventsByRoundIdQuery = {
  __typename: 'query_root';
  competitions_event_detail_by_round_day_id:
    | Array<{
        __typename: 'competitions_event_detail';
        id: number;
        status: string | undefined;
        time: unknown;
        date: unknown;
        teams: unknown;
        level_name: string | undefined;
        url: string | undefined;
        place:
          | { __typename: 'places_place'; id: number; name: string | undefined }
          | undefined;
      }>
    | undefined;
};

export const CompetitionQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CompetitionQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      directives: [
        {
          kind: 'Directive',
          name: { kind: 'Name', value: 'cached' },
          arguments: [
            {
              kind: 'Argument',
              name: { kind: 'Name', value: 'ttl' },
              value: { kind: 'IntValue', value: '100' },
            },
          ],
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'competitions_competition_detail_by_id',
            },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'args' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'age_category' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'family' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fede_url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
                { kind: 'Field', name: { kind: 'Name', value: 'league_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'level_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'level_in_season_id' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'level_slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'old_url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'competition' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'current_round' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sport' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rounds' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'order_by' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'start_date' },
                            value: { kind: 'EnumValue', value: 'asc' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'events' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'order_by' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'date' },
                                  value: { kind: 'EnumValue', value: 'asc' },
                                },
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'time' },
                                  value: { kind: 'EnumValue', value: 'asc' },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'event_with_same_team',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'slug' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rankings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'name_in_competition' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'pts' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'even' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ga' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'gd' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'gf' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'logo' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lost' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'played' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'ratio' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'team_id' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'team_in_season_id' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'win' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'club_id' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'serie' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'extra_columns' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'league' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'level' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CompetitionQueryQuery,
  CompetitionQueryQueryVariables
>;
export const EventsByRoundIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EventsByRoundId' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'roundId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      directives: [
        {
          kind: 'Directive',
          name: { kind: 'Name', value: 'cached' },
          arguments: [
            {
              kind: 'Argument',
              name: { kind: 'Name', value: 'ttl' },
              value: { kind: 'IntValue', value: '30' },
            },
          ],
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'competitions_event_detail_by_round_day_id',
            },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'args' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'round_day_id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'roundId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'EventItem' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'competitions_event_detail' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'time' } },
          { kind: 'Field', name: { kind: 'Name', value: 'date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teams' } },
          { kind: 'Field', name: { kind: 'Name', value: 'level_name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EventsByRoundIdQuery,
  EventsByRoundIdQueryVariables
>;
